export default {
  carousel: '/carousel',
  allCarousel: '/carousel/all-carousel',
}
